var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.58 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M659.89,380.69a5.66,5.66,0,0,1-1.5,4.21,5.83,5.83,0,0,1-4.23,1.48h-3.53V375.46h3.77a5.67,5.67,0,0,1,4.06,1.35A5.07,5.07,0,0,1,659.89,380.69Zm-3.06.1a3.48,3.48,0,0,0-.59-2.22,2.22,2.22,0,0,0-1.81-.73h-.86V384h.66a2.37,2.37,0,0,0,2-.78A3.77,3.77,0,0,0,656.83,380.79Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.19,386.38l-.56-1.12h-.06a3.26,3.26,0,0,1-1.2,1,4,4,0,0,1-1.58.27,2.46,2.46,0,0,1-1.88-.72,2.8,2.8,0,0,1-.69-2,2.28,2.28,0,0,1,.94-2,5.09,5.09,0,0,1,2.72-.74l1.41,0v-.12a.92.92,0,0,0-1-1.05,6.16,6.16,0,0,0-2.35.63l-.84-1.93a8.07,8.07,0,0,1,3.73-.76,3.6,3.6,0,0,1,2.52.81,2.85,2.85,0,0,1,.89,2.25v5.55ZM665,384.47a1.32,1.32,0,0,0,.9-.34,1.11,1.11,0,0,0,.38-.87v-.66l-.67,0c-1,0-1.44.39-1.44,1.06C664.2,384.21,664.47,384.47,665,384.47Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.3,377.77a4.23,4.23,0,0,1,.73.06l.16,0-.26,2.75a4.27,4.27,0,0,0-1-.09,1.9,1.9,0,0,0-1.39.44,1.7,1.7,0,0,0-.43,1.26v4.16H671.2v-8.46h2.17l.46,1.35H674a2.88,2.88,0,0,1,1-1.09A2.45,2.45,0,0,1,676.3,377.77Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.52,384.22a4.47,4.47,0,0,0,1.41-.29v2.13a5.64,5.64,0,0,1-1.13.36,6.45,6.45,0,0,1-1.25.11,2.74,2.74,0,0,1-2.12-.72,3.25,3.25,0,0,1-.65-2.22v-3.48h-1v-1.19l1.3-.92.75-1.77h1.91v1.69h2.08v2.19h-2.08v3.29A.72.72,0,0,0,682.52,384.22Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.94,383.78a2.39,2.39,0,0,1-.93,2.05,4.39,4.39,0,0,1-2.66.7,12.7,12.7,0,0,1-1.63-.1,6.92,6.92,0,0,1-1.42-.37v-2.34a8.68,8.68,0,0,0,1.49.49,6.27,6.27,0,0,0,1.44.2c.63,0,.95-.15.95-.44a.5.5,0,0,0-.26-.4,13.75,13.75,0,0,0-1.55-.68,3.92,3.92,0,0,1-1.62-1.08,2.49,2.49,0,0,1-.47-1.55,2.13,2.13,0,0,1,.92-1.83,4.3,4.3,0,0,1,2.57-.66,6.56,6.56,0,0,1,1.57.18,9.71,9.71,0,0,1,1.53.54l-.79,1.88a9.43,9.43,0,0,0-1.23-.45,4.23,4.23,0,0,0-1.06-.18c-.48,0-.72.12-.72.35a.42.42,0,0,0,.25.37,14.15,14.15,0,0,0,1.44.62,5.78,5.78,0,0,1,1.33.72,2.21,2.21,0,0,1,.64.83A2.81,2.81,0,0,1,691.94,383.78Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.41,386.53a4.17,4.17,0,0,1-3.15-1.12,4.5,4.5,0,0,1-1.07-3.22,4,4,0,0,1,4.45-4.42,6.15,6.15,0,0,1,2.77.64l-.86,2.16a9.49,9.49,0,0,0-1-.37,3.22,3.22,0,0,0-.93-.14,1.29,1.29,0,0,0-1.1.55,2.68,2.68,0,0,0-.39,1.56c0,1.36.5,2,1.5,2a4.53,4.53,0,0,0,2.47-.74v2.32A4.79,4.79,0,0,1,697.41,386.53Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.12,386.38v-4.62c0-1.13-.34-1.7-1-1.7a1.14,1.14,0,0,0-1.06.6,4.4,4.4,0,0,0-.34,2v3.72H701.8V374.76h2.91v1.65c0,.75,0,1.6-.11,2.55h.13a2.46,2.46,0,0,1,1-.92,3.14,3.14,0,0,1,1.34-.27,2.89,2.89,0,0,1,2.2.82,3.14,3.14,0,0,1,.79,2.29v5.5Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.12,386.53a4.54,4.54,0,0,1-3.28-1.13,4.22,4.22,0,0,1-1.17-3.2,4.6,4.6,0,0,1,1.08-3.28,4.05,4.05,0,0,1,3.09-1.15,4.1,4.1,0,0,1,3,1,3.79,3.79,0,0,1,1,2.87v1.3h-5.22a1.44,1.44,0,0,0,.52,1.11,2,2,0,0,0,1.33.4,7,7,0,0,0,1.42-.14,7.7,7.7,0,0,0,1.4-.5v2.1a5.41,5.41,0,0,1-1.42.48A9.76,9.76,0,0,1,716.12,386.53Zm-.17-6.77a1.19,1.19,0,0,0-.86.32,1.55,1.55,0,0,0-.41,1h2.51a1.48,1.48,0,0,0-.35-1A1.15,1.15,0,0,0,716,379.76Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.87,386.38v-4.6a2.89,2.89,0,0,0-.23-1.29.81.81,0,0,0-.75-.43,1,1,0,0,0-1,.58,3.88,3.88,0,0,0-.32,1.8v3.94h-2.92v-4.6a2.89,2.89,0,0,0-.23-1.29.77.77,0,0,0-.72-.43,1.06,1.06,0,0,0-1,.61,4.69,4.69,0,0,0-.31,2v3.71h-2.92v-8.46h2.2l.37,1h.17a2.19,2.19,0,0,1,1-.88,3.25,3.25,0,0,1,1.45-.31,2.85,2.85,0,0,1,2.57,1.11h.23a2.31,2.31,0,0,1,1-.81,3.24,3.24,0,0,1,1.41-.3,2.88,2.88,0,0,1,2.21.77,3.31,3.31,0,0,1,.72,2.34v5.5Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.29,386.38l-.56-1.12h-.06a3.26,3.26,0,0,1-1.2,1,4,4,0,0,1-1.58.27,2.46,2.46,0,0,1-1.88-.72,2.8,2.8,0,0,1-.69-2,2.28,2.28,0,0,1,.94-2A5.12,5.12,0,0,1,740,381l1.42,0v-.12a.92.92,0,0,0-1-1.05,6.16,6.16,0,0,0-2.36.63l-.84-1.93a8.09,8.09,0,0,1,3.73-.76,3.6,3.6,0,0,1,2.52.81,2.85,2.85,0,0,1,.89,2.25v5.55Zm-2.16-1.91a1.32,1.32,0,0,0,.9-.34,1.11,1.11,0,0,0,.38-.87v-.66l-.67,0c-1,0-1.44.39-1.44,1.06C739.3,384.21,739.57,384.47,740.13,384.47Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.93,385.14a1.37,1.37,0,0,1,.41-1.06,1.69,1.69,0,0,1,1.18-.38,1.6,1.6,0,0,1,1.14.38,1.4,1.4,0,0,1,.39,1.06,1.36,1.36,0,0,1-.4,1.05,1.6,1.6,0,0,1-1.13.37,1.68,1.68,0,0,1-1.16-.37A1.34,1.34,0,0,1,745.93,385.14Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.06,386.38v-4.62a2.55,2.55,0,0,0-.25-1.27.84.84,0,0,0-.78-.43,1.13,1.13,0,0,0-1.06.59,4.44,4.44,0,0,0-.33,2v3.71h-2.92v-8.46h2.2l.37,1h.17a2.35,2.35,0,0,1,1-.89,3.65,3.65,0,0,1,1.52-.3,2.87,2.87,0,0,1,2.18.81,3.2,3.2,0,0,1,.78,2.3v5.5Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.88,386.38H761V374.76h2.92Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.14,374.64c3,4.47,1.36,14.61-.26,15.68-2,1.35-11.57-1.41-14.53-5.89s1.13-12.4,2.39-13.23C631.21,370.22,639.18,370.16,642.14,374.64Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#43834a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.7,371.23c-.78.52-2.56,6.91.4,11.38s10.06,8.17,11.52,7.49l-11.85-18.91Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#59a965"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.36,376.86c-2.9-4.38-8.5-6.17-9.59-5.67l11.85,18.91.08,0C642.71,389.39,642.32,381.33,639.36,376.86Z",
    transform: "translate(-626.29 -370.66)",
    style: {
      fill: "#599b60"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c81b9af90cd9f0d08824e19696293497.svg";
export { ForwardRef as ReactComponent };